import React from 'react';

const Resumes = () => {
    return (
        <div>
            
        </div>
    );
};

export default Resumes;